module.exports = __webpack_public_path__ + "img/solico.75aff15.webp";